export const EDUCATOR_ROLE = 'educator';
export const STUDENT_ROLE = 'student';
export const STAFF_ROLE = 'staff';

export type UserSpaceRole =
  | typeof EDUCATOR_ROLE
  | typeof STUDENT_ROLE
  | typeof STAFF_ROLE;

// My Nav Space
export const COMMUNITIES_AND_TRAINING = 'Communities and training';
export const PREVIOUS_ACADEMIC_YEARS = 'Previous academic years';
